import { mrpLocationChipStyles } from "@/lib/mrp";
import { cn } from "@/lib/utils";

export function MrpLocationChip({ code }: { code: string }): JSX.Element {
  const { label, className } = mrpLocationChipStyles(code);
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium",
        className,
      )}
    >
      {label}
    </span>
  );
}
